import { render, staticRenderFns } from "./stigler.vue?vue&type=template&id=500312d6&lang=pug&"
import script from "./stigler.vue?vue&type=script&lang=js&"
export * from "./stigler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports